import { createSlice } from '@reduxjs/toolkit';
import api, { setLoggingOut } from 'api';
import { mergeRolesToSingleRole } from '../../utils/mergeRoles';
import formErrorsHandle from '../../utils/formErrorsHandle';
import { stopTokenRefresh } from '../../utils/tokenRefreshManager';
// import * as toast from 'components/Toast/toast';

const loadAuthState = () => {
  const token =
    localStorage.getItem('token') || sessionStorage.getItem('token');
  const user = localStorage.getItem('user') || sessionStorage.getItem('user');
  const role = localStorage.getItem('role') || sessionStorage.getItem('role');
  const isAuthenticated =
    localStorage.getItem('isAuthenticated') ||
    sessionStorage.getItem('isAuthenticated');

  if (token && user && role) {
    return {
      isAuthenticated: isAuthenticated,
      user: JSON.parse(user),
      token: token,
      role: role,
      loading: false,
      errors: undefined
    };
  }
  return {
    isAuthenticated: isAuthenticated,
    loading: false,
    auth: [],
    authCount: 0,
    errors: undefined
  };
};

const initialState = loadAuthState();

const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    getAuth(state, action) {
      state.user = action.payload;
      state.token = action.payload.token;
      state.isAuthenticated = true;
      state.role = action.payload.role;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    updateToken(state, action) {
      state.token = action.payload;
    },
    logout() {
      return {
        loading: false,
        auth: [],
        authCount: 0,
        errors: undefined,
        isAuthenticated: false,
        token: null,
        user: null,
        role: null
      };
    }
  }
});

export default auth.reducer;

export const AuthActions = auth.actions;

export const authLogin = ({ email, password, remember }) => {
  return async (dispatch) => {
    dispatch(AuthActions.setLoading(true));
    dispatch(AuthActions.setErrors([]));
    try {
      const res = await api.post('api/User/login', {
        email: email,
        password: password
      });
      if (res.status === 200 && res && res.data) {
        const respData = res.data?.data;
        const roles = mergeRolesToSingleRole(respData.roles);
        if (remember) {
          localStorage.setItem('token', respData.token);
          localStorage.setItem('user', JSON.stringify(respData));
          localStorage.setItem('role', JSON.stringify(roles));
          localStorage.setItem('isAuthenticated', 'true');
        } else {
          sessionStorage.setItem('token', respData.token);
          sessionStorage.setItem('user', JSON.stringify(respData));
          sessionStorage.setItem('role', JSON.stringify(roles));
          sessionStorage.setItem('isAuthenticated', 'true');
        }
        return Promise.resolve(respData);
      }
    } catch (authErrors) {
      return Promise.reject(authErrors.response?.data || authErrors.message);
    } finally {
      dispatch(AuthActions.setLoading(false));
    }
  };
};
export const authRegisterCompany = (data) => {
  return async (dispatch) => {
    dispatch(AuthActions.setLoading(true));
    dispatch(AuthActions.setErrors([]));
    try {
      const res = await api.post('api/User/RegisterProvider', data);
      if (res.status === 200 && res && res.data) {
        const respData = res.data?.data;
        const roles = mergeRolesToSingleRole(respData.roles);
        localStorage.setItem('token', respData.token);
        localStorage.setItem('user', JSON.stringify(respData));
        localStorage.setItem('role', JSON.stringify(roles));
        localStorage.setItem('isAuthenticated', 'true');
        return Promise.resolve(respData);
      }
    } catch (authErrors) {
      return Promise.reject(authErrors.response?.data || authErrors.message);
    } finally {
      dispatch(AuthActions.setLoading(false));
    }
  };
};
export const authForgotPassword = (email) => async () => {
  try {
    // const params = `"${email}"`;
    const respData = await api.post(
      'api/User/send-forgot-password-email-confirmation',
      { email },
      {
        headers: {
          accept: 'text/plain',
          'Content-Type': 'application/json-patch+json'
        }
      }
    );
    return Promise.resolve(respData);
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};

export const authChangeForgotPassword = (params, isSetPassword) => async () => {
  try {
    const respData = await api.post(
      !isSetPassword ? 'api/User/forgot-password' : 'api/User/set-password',
      params
    );
    return Promise.resolve(respData);
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};

export const sendEmail = (email) => async () => {
  try {
    const respData = await api.post('api/Auth/Email', email);
    return Promise.resolve(respData);
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};

export const registerGuest = (data) => async () => {
  try {
    const respData = await api.post('api/Auth/Register', data);
    return Promise.resolve(respData);
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};

export const authGoogleGuest = (data) => async () => {
  try {
    const res = await api.post('api/Auth/google-register-login', data);
    if (res.status === 200 && res && res.data) {
      const respData = res.data?.message;
      const roles = mergeRolesToSingleRole(respData.roles);
      localStorage.setItem('token', respData.token);
      localStorage.setItem('user', JSON.stringify(respData));
      localStorage.setItem('role', JSON.stringify(roles));
      localStorage.setItem('isAuthenticated', 'true');
      return Promise.resolve(respData);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response.message);
  }
};
export const emailVerification = (data) => async () => {
  try {
    const respData = await api.post('api/User/email-verification', data);
    return Promise.resolve(respData);
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export const authLogout = () => async (dispatch) => {
  setLoggingOut(true);
  stopTokenRefresh();

  try {
    await api.post('api/User/logout');
  } catch (error) {
    console.error('Logout API call failed:', error);
  } finally {
    const settings = localStorage.getItem('settings');
    localStorage.clear();
    sessionStorage.clear();
    if (settings) {
      localStorage.setItem('settings', settings);
    }

    dispatch(AuthActions.logout());
    window.location.href = '/';
  }
};
